import type { RailwayAuthResult, RailwayRunner } from '@cli-types/next-adapter/railway.js'
import { WHOAMI_TIMEOUT_MS } from '@cli-constants/timeouts.js'
import { parseRailwayJson } from '@next-adapter/init/railway/runner/parse-railway-json.js'
import { runRailway } from '@next-adapter/init/railway/runner/run-railway.js'

export async function checkRailwayProjectToken(
  runner: RailwayRunner,
  cwd: string,
  env: NodeJS.ProcessEnv
): Promise<RailwayAuthResult> {
  const result = await runRailway(runner, ['status', '--json'], {
    cwd,
    mode: 'capture',
    timeoutMs: WHOAMI_TIMEOUT_MS,
    env
  })
  if (!result.success) {
    return { authed: false, reason: result.timedOut ? 'timeout' : 'invalid-token' }
  }

  const project = parseRailwayJson<unknown>(result.stdout)
  if (!project || typeof project !== 'object') return { authed: false, reason: 'failed' }
  const record = project as Record<string, unknown>
  return typeof record.id === 'string' && typeof record.name === 'string'
    ? { authed: true }
    : { authed: false, reason: 'failed' }
}
